<template>
    <v-container fluid grid-list-lg class='pa-0 py-0'>
      <h3 class='ml-2 mb-3'><v-icon medium class='mr-2' color='black'>far fa-comments</v-icon> My Groups</h3>
      <p class='px-2'>Collaborate and share in Amaze groups. Create your own group by selecting add a group or join a group by selecting find a group.</p>
        <v-layout row wrap>
            <v-flex
                xs12
                sm6
                md4
                lg3
                v-for="group in groups"
                :key="group.id"
            >
              <AmazeDashboardTile :group="group" class='ma-2' :link="'/group/' + group.id" :photo-url="group.group_photo.large">
                  <template slot="card-actions">
                      <small class='latestActivity pl-2' v-if="group.updated_at">Last Activity: {{ group.updated_at | localTime }} ago</small>
                  </template>
              </AmazeDashboardTile>
            </v-flex>
            <v-flex xs12 sm6 md4 lg3>
                <AmazeDashboardIconTile class='ma-2' icon="add" text="Add a Group" link="/group/create" />
            </v-flex>
            <v-flex xs12 sm6 md4 lg3>
                <AmazeDashboardIconTile class='ma-2' icon="search" text="Find a Group" link="/group/find" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import AmazeDashboardTile from "@/components/Widgets/AmazeDashboardTile";
import AmazeDashboardIconTile from "@/components/Widgets/AmazeDashboardIconTile";

export default {
  components: {
    AmazeDashboardTile,
    AmazeDashboardIconTile
  },
  props: ['groups']
};
</script>
